/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import { InputSearchPro } from 'components/InputSearch';
import { toMoment } from 'utils/normalizers';
import { ciudadanoToString, contribuyenteToString, predioToString } from 'utils/padronesToString';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import BusquedaAvanzadaSCIAN from 'components/BusquedaAvanzadaSCIAN';
import { dataTypesEnum, padronesEnum } from '../enums';

const fieldsInfo = {
  _giros_comerciales: {
    id: '_giros_comerciales',
    nombre_en_la_bd: '_giros_comerciales',
    tipo_de_dato_del_campo: dataTypesEnum.TEXT,
  },
};

const tabs = [
  {
    title: 'Datos Generales',
    fields: [
      'nombre_comercial',
      'contribuyente',
      'unidad_recaudadora',
      'ciudadano',

      'sector_empresarial',
    ],
  },
  {
    title: 'Datos de contacto',
    fields: [
      'nombre_del_gerente_propietario',
      'lada_fijo',
      'lada_celular',
      'sitio_de_internet',
      'correo_electronico',
    ],
  },
  {
    title: 'Clasificación Empresarial',
    fields: [
      'tipo_de_empresa',
      'tipo_de_establecimiento',
      'clasificacion_de_comercio',
      'fecha_de_apertura',
      'fecha_de_cierre',
      'fecha_de_alta_de_padron_empresa',
      'clase_actividad_empresarial_principal',
      'giros_scian',
      'observaciones',
    ],
  },
  {
    title: 'Datos Complementarios',
    fields: [
      'predio',
      'superficie_del_terreno',
      'superficie_construida_del_terreno',
      'zona_de_carga_descarga',
      'tiene_estacionamiento',
      'numero_de_cajones_de_estacionamiento',
      'estacionamiento_descripcion',
      'numero_de_empleados',
    ],
  },
  process.env.REACT_APP_ENV_NAME === 'oaxaca' && {
    title: '',
    fields: ['_giros_comerciales'],
  },
].filter((e) => e);

const configs = {
  // info general
  es_informal: {
    formItemProps: {
      label: '¿Es informal?',
      tooltip: 'Se establece si es empresa informal o formal',
      required: true,
    },
  },
  nombre_comercial: {
    formItemProps: {
      label: 'Nombre comercial',
      required: true,
    },
  },
  nombre_del_gerente_propietario: {
    formItemProps: {
      label: 'Nombre de Gerente Propietario',
      required: true,
    },
  },
  lada_fijo: {
    controlProps: {
      names: {
        lada: 'lada_fijo',
        numero_de_telefono: 'telefono_fijo',
      },
      label: 'Teléfono Fijo',
      tooltip: 'Teléfono Fijo de la Empresa',
      fullSize: true,
    },
  },
  lada_celular: {
    controlProps: {
      names: {
        lada: 'lada_celular',
        numero_de_telefono: 'telefono_celular',
      },
      label: 'Teléfono Celular',
      tooltip: 'Teléfono Celular de la Empresa',
      fullSize: true,
    },
  },
  sitio_de_internet: {
    formItemProps: {
      label: 'Sitio de Internet',
    },
  },
  correo_electronico: {
    formItemProps: {
      label: 'Correo electrónico',
    },
  },
  sector_empresarial: {
    formItemProps: {
      label: 'Sector empresarial',
    },
    controlProps: {
      labelProp: 'titulo',
    },
  },
  clasificacion_de_comercio: {
    formItemProps: {
      label: 'Clasificación de comercio',
    },
  },
  tipo_de_establecimiento: {
    formItemProps: {
      label: 'Tipo de Establecimiento',
    },
    controlProps: {
      labelProp: 'nombre',
    },
  },
  predio: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.PREDIO, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Predio',
    tooltip: 'Búsqueda por Cuenta Unica Predial',
    resultProps: {
      name: 'predio',
      label: 'Predio',
      render: (predio) => predioToString(predio),
    },
  },
  // info empresarial
  fecha_de_apertura: {
    formItemProps: {
      label: 'Fecha de apertura',
    },
  },
  fecha_de_cierre: {
    formItemProps: {
      label: 'Fecha de cierre',
    },
  },
  tipo_de_empresa: {
    formItemProps: {
      label: 'Tipo de Empresa',
    },
  },
  fecha_de_alta_de_padron_empresa: {
    formItemProps: {
      label: 'Fecha de alta de Padrón',
    },
    defaultValue: toMoment(new Date()),
    controlProps: {
      disabled: true,
    },
  },
  superficie_del_terreno: {
    formItemProps: {
      label: 'Superficie del Terreno',
    },
  },
  superficie_construida_del_terreno: {
    formItemProps: {
      label: 'Superficie Construida del Terreno',
    },
  },
  tiene_estacionamiento: {
    formItemProps: {
      label: 'Estacionamiento',
    },
    hideOnFalsy: ['numero_de_cajones_de_estacionamiento', 'estacionamiento_descripcion'],
  },
  numero_de_cajones_de_estacionamiento: {
    formItemProps: {
      label: 'Cajones de Estacionamiento',
    },
  },
  estacionamiento_descripcion: {
    formItemProps: {
      label: 'Descripción Estacionamiento',
    },
  },
  zona_de_carga_descarga: {
    formItemProps: {
      label: 'Zona de Carga/Descarga',
      tooltip: 'Metros cuadrados o lineales indicados como zona de carga y descarga',
    },
  },
  ciudadano: {
    params: [''], // prevent fill
    formItemProps: {
      label: 'Ciudadano',
      rules: [
        ({ getFieldValue }) => ({
          validator: async (rule, _value) => {
            if (!_value && !getFieldValue('contribuyente')) {
              throw new Error('Debe asignar al menos Ciudadano o Contribuyente');
            }
          },
        }),
      ],
    },
    controlProps: {
      render: (ciudadano) => ciudadanoToString(ciudadano),
      allowClear: false,
    },
  },
  clase_actividad_empresarial_principal: {
    formItemProps: {
      label: 'Clase Actividad',
      tooltip: 'Clase Actividad Local',
    },
  },
  observaciones: {
    formItemProps: {
      label: 'Observaciones',
    },
    colProps: { md: 16 },
    controlProps: {
      autoSize: { minRows: 1, maxRows: 1 },
    },
  },
  // datos fiscales
  unidad_recaudadora: {
    formItemProps: {
      label: 'Unidad Recaudadora',
    },
  },
  numero_de_empleados: {
    formItemProps: {
      label: 'No. de empleados',
    },
  },
  _giros_comerciales: {
    formItemProps: {
      label: 'Giros',
    },
    controlProps: {
      autoSize: { minRows: 5, maxRows: 5 },
      disabled: true,
    },
    colProps: { md: 24 },
  },
  contribuyente: {
    params: [''], // prevent fill
    formItemProps: {
      label: 'Contribuyente',
      rules: [
        ({ getFieldValue }) => ({
          validator: async (_, _value) => {
            if (!_value && !getFieldValue('ciudadano')) {
              throw new Error('Debe asignar al menos Ciudadano o Contribuyente');
            }
          },
        }),
      ],
    },
    controlProps: {
      render: (contribuyente) => contribuyenteToString(contribuyente),
      allowClear: false,
    },
  },
  giros_scian: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaSCIAN,
    advancedComponentProps: {},
    advancedComponentName: 'BusquedaAvanzadaSCIAN',
    label: 'Clase de actividad SCIAN',
    tooltip: 'Búsqueda de actividades económicas',
    resultProps: {
      name: 'giros_scian',
      label: 'Clase de actividad SCIAN',
      labelProp: 'titulo',
      keyProp: 'codigo',
      keyLabelRender: true,
    },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
